import React, { FC, useEffect, useState } from 'react';
import { IconButton, StandardTextFieldProps, TextField } from '@material-ui/core';
import { BsEyeFill as ViewIcon } from '@react-icons/all-files/bs/BsEyeFill';
import { Skeleton } from '@material-ui/lab';
import { Link } from 'react-router-dom';
import useEmployeeAccess from '../../../../../../../hooks/api/useEmployeeAccess';
import { useRecoilState } from 'recoil';
import { employeeState } from '../../../../../../../recoil/selectors/employees';

interface Props extends StandardTextFieldProps {
  employeeId: string;
  seeMore?: boolean;
  label: string;
}

const EmployeeField: FC<Props> = ({ employeeId, label, seeMore = true, ...props }) => {
  const { get } = useEmployeeAccess();
  const [loading, setLoading] = useState(false);
  const [employee, setEmployee] = useRecoilState(employeeState(employeeId));
  const [error, setError] = useState<string>();

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    get(employeeId)
      .then((employee) => {
        setEmployee(employee);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(e.message);
      });
  }, [employeeId]);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <TextField
      variant='outlined'
      label={label}
      defaultValue={`${employee?.firstname} ${employee?.lastname}`}
      InputProps={{
        readOnly: true,
        endAdornment: seeMore && employee?.legacyUserId && (
          <IconButton component={Link} to={`/dashboard/user/${employee.legacyUserId}`}>
            <ViewIcon color='#0000008a' />
          </IconButton>
        ),
      }}
      fullWidth
      {...props}
    />
  );
};

export default React.memo(EmployeeField);
